import { routes as traAbastecimento } from './traabastecimento';
import { routes as traDespesa } from './tradespesa';
import { routes as traPeca } from './trapeca';
import { routes as traServico } from './traservico';
import { routes as traUsuarioAdicional } from './trausuarioadicional';
import { routes as traVeiculo } from './traveiculo';
import { routes as traRota } from './trarota';
import { routes as traAluno } from './traaluno';
import { routes as traPassagemAluno } from './trapassagemaluno';
import { routes as traEmissaoPasse } from './traemissaopasse';
import { routes as traSolicitacaoPasseTurma } from './trasolicitacaopasseturma';
import { routes as traQuadroResumo } from './traquadroresummo';
import { routes as traRelatorioTransporte } from './trarelatoriotransporte';
import { routes as traRelatorioMapaViagens } from './trarelatoriomapaviagens';
import { routes as traViagem } from './traviagem';
import { routes as traRelatorioTransporteAluno } from './trarelatoriotransportealuno';
import { routes as traRelatorioMatriculados } from './trarelatoriomatriculados';
import { routes as traParametro } from './traparametro';
import { routes as traPessoal } from './trapessoal';
import { routes as traEstruturaInspecao } from './traestruturainspecao';
import { routes as integracaoSETE } from './integracaoSETE';

export default [
  {
    path: '/transporte',
    name: 'Transporte',
    description: 'Transporte',
    icon: 'uil-bus',
    goesToMenu: true,
    children: [
      ...traViagem,
      ...traVeiculo,
      ...traRota,
      ...traAluno,
      ...traPassagemAluno,
      ...traEmissaoPasse,
      ...traSolicitacaoPasseTurma,
      ...traQuadroResumo,
      ...traRelatorioTransporte,
      ...traRelatorioMapaViagens,
      ...traAbastecimento,
      ...traServico,
      ...traPeca,
      ...traDespesa,
      ...traUsuarioAdicional,
      ...traPessoal,
      ...traEstruturaInspecao,
      ...traRelatorioTransporteAluno,
      ...traRelatorioMatriculados,
      ...traParametro,
      ...integracaoSETE,
    ],
  },
];
